import gql from 'graphql-tag';

export const LISTING_AMENITIES_FRAGMENT = gql`
    fragment LISTING_AMENITIES_FRAGMENT on ListingData {
        pointsOfInterest {
            title
            type
            distanceMiles
        }
    }
`;
